import { DateTime } from "luxon";

import {
  EstimatedTestLengthRangeType,
  ExperienceAnalyticsStatus,
} from "@intelligems/ig-types";
import { Experience } from "@src/store/slices/experiences/types";
import { getDaysBetweenDates } from "@src/utils/dateConverters";

export const calculateStatus = (
  experience: Experience
): { label: ExperienceAnalyticsStatus; status: "warning" | "success" } => {
  const estimatedRange: EstimatedTestLengthRangeType = {
    low: experience.experienceAnalysis?.estimatedTestLengthRange?.low || 21,
    high: experience.experienceAnalysis?.estimatedTestLengthRange?.high || 21,
  };

  const timeLive = getDaysBetweenDates(
    experience.startedAtTs!,
    DateTime.now().toMillis()
  );

  if (timeLive < estimatedRange.low!) {
    return { label: "Gathering Data", status: "warning" };
  } else {
    return { label: "Ready for Analysis", status: "success" };
  }
};
